import React from "react";

function PropertyTable({
  properties = [],
  session,
  onEdit,
  onImages,
  onDelete,
}) {
  return (
    <div className="table-responsive mt-4">
      <table className="table table-striped table-hover align-middle">
        <thead className="table-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Title</th>
            <th scope="col">Location</th>
            <th scope="col">Price</th>
            <th scope="col">Featured</th>
            <th scope="col" className="text-end">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {properties.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center text-muted">
                No properties available.
              </td>
            </tr>
          ) : (
            properties.map((p) => (
              <tr key={p.id}>
                <td>{p.id}</td>
                <td>{p.title || "Untitled Property"}</td>
                <td>{p.location || "Location not specified"}</td>
                <td>PHP {p.price || "N/A"}</td>
                <td>{Number(p.featured) === 1 ? "Yes" : "No"}</td>
                <td className="text-end">
                  <div className="dropdown">
                    <button
                      className="btn btn-sm btn-secondary dropdown-toggle"
                      type="button"
                      id={`dropdown-${p.id}`}
                      data-bs-toggle="dropdown"
                      data-bs-display="static"
                      aria-expanded="false"
                    >
                      Actions
                    </button>
                    <ul
                      className="dropdown-menu dropdown-menu-end"
                      aria-labelledby={`dropdown-${p.id}`}
                    >
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => onEdit?.(p)}
                        >
                          Edit
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => onImages?.(p.id)}
                        >
                          Images
                        </button>
                      </li>
                      {session?.role === "admin" && (
                        <li>
                          <button
                            className="dropdown-item text-danger"
                            onClick={() => onDelete?.(p.id)}
                          >
                            Delete
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default PropertyTable;
